export const loaders = {
  OVERLAY: 'OVERLAY',
  TOPBAR: 'TOPBAR'
};

export const PLATFORMS = Object.freeze({
  XERO: 'xero',
  QUICKBOOKS: 'quickbooks',
  MYOB: 'myob'
});

export const SYNC_POLL_INTERVALS = Object.freeze({
  ACTIVE_SYNC: 3500,
  MAX_RETRIES: 30,
  MAX_INTERVAL_MS: 10000,
  ESTIMATED_ITEM_MS: 1500
});

/**
 * Calculates a dynamic polling interval based on item count for sync jobs.
 * @param {number} itemCount - Number of items being synchronized
 * @returns {number} Interval in milliseconds
 */
export const calculateSyncPollInterval = (itemCount = 0) => {
  return Math.max(
    SYNC_POLL_INTERVALS.ACTIVE_SYNC,
    Math.min(
      SYNC_POLL_INTERVALS.MAX_INTERVAL_MS,
      Math.ceil((itemCount * SYNC_POLL_INTERVALS.ESTIMATED_ITEM_MS) / SYNC_POLL_INTERVALS.MAX_RETRIES)
    )
  );
};

